import {getPrivateAxios} from '@blesk-frontend/api';

export interface AuthVerifyData {
  email: string;
  code: string;
  staffId: string | undefined;
}

interface AuthVerifyResponse {
  accessToken: string;
  isSignUp: boolean;
}

/**
 *
 * @param data
 */
export const fetchAuthVerify = async (data: AuthVerifyData) => {
  const response = await getPrivateAxios().post<AuthVerifyResponse>('/auth/verify', data);
  return response.data;
};
